import * as ACTION from 'constant/action'

export default (imageMeta) => {
  if (imageMeta?.status === ACTION.REMOVED) {
    return { file: ACTION.REMOVED }
  }
  return imageMeta && { file: imageMeta }
}
